import { render } from "./IncidentStatus.vue?vue&type=template&id=24209cac"
import script from "./IncidentStatus.vue?vue&type=script&lang=js"
export * from "./IncidentStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__